import React from 'react';

import PropTypes from 'prop-types';

import Card from '@/components/common/Card';
import userIcon from '@/components/common/icons/user.svg';
import urlPrefix from '@/helpers/url-prefix';

const UserCard = ({ data }) => (
  <Card className="isInspector" url={`${urlPrefix('users')}/${data.id}`}>
    <div className="flex items-center">
      <div className="relative w-[24px] mr-[0.5em] text-[#45668c] leading-[0] shrink-0">
        <img src={userIcon} alt="Usuário" className="max-w-full max-h-full" />
      </div>
      <div className="text-[0.875em] leading-none font-bold text-[#393939] truncate">
        {data.username}
      </div>
    </div>
    {(data.phone || data.email) && (
      <div className="flex mt-[1em] text-[0.8125em] text-[#919191]">
        {data.phone && <div className="font-bold">{data.phone}</div>}
        {data.email && (
          <div className={`font-semibold ${data.phone ? 'before:content-["•"] before:mx-[5px]' : ''}`}>
            {data.email}
          </div>
        )}
      </div>
    )}
  </Card>
);

UserCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default UserCard;
